enum RoutingNumberLengthEnum {
    UK = 6,
    CANADIAN_EFT = 9,
    CANADIAN_MICR = 8,
    USA_ABA = 9
}

export default RoutingNumberLengthEnum;

